import { NCFileVersion as NCFileVersionType } from '@interfaces/search';

// Swaps the slot holding currentVersionId with nextVersion; returns the same reference on a no-op (avoids needless re-render/refetch).
export const replaceVersionInPair = (
  pair: NCFileVersionType[] | null,
  currentVersionId: number,
  nextVersion: NCFileVersionType
): NCFileVersionType[] | null => {
  if (!pair || pair.length !== 2) {
    return pair;
  }
  const index = pair.findIndex((v) => v.ncFileVersionId === currentVersionId);
  if (index === -1) {
    return pair;
  }
  const otherIndex = index === 0 ? 1 : 0;
  if (pair[otherIndex].ncFileVersionId === nextVersion.ncFileVersionId) {
    return pair;
  }
  const updated = [...pair];
  updated[index] = nextVersion;
  return updated;
};
